<div class="detail-content__section" *ngFor="let text of texts | orderBy: 'order'">
  <div class="row detail-content__row">
    <div class="col-12 col-lg-2">
      <h5 class="detail-steps__title mb-4">{{text.title}}</h5>
    </div>
    <div class="col-12 col-lg-10">
      <div class="detail-steps">
        <div class="detail-steps__description detail-steps__text" [innerHTML]="text.description"></div>
      </div>
    </div>
  </div>
  <hr class="hr hr--grey dashed-border">
</div>
